// A new recipient must not inherit the sender's ad click or cross-domain identity.
const CLICK_IDENTIFIERS = new Set(['gclid', 'dclid', 'gclsrc', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid', 'srsltid', '_gl', 'fbclid', 'msclkid', 'ttclid', 'twclid'])

/** Attribute this visit to the influencer's Share link, preserving the page, filters and anchor. */
export function influencerShareUrl(currentUrl: string, couponCode: string): string {
  const url = new URL(currentUrl)
  for (const key of [...url.searchParams.keys()]) {
    if (key.toLowerCase().startsWith('utm_') || CLICK_IDENTIFIERS.has(key.toLowerCase()))
      url.searchParams.delete(key)
  }
  url.searchParams.set('code', couponCode)
  // The native sheet does not expose the chosen app. Use a neutral source and
  // GA4's affiliate medium; the public coupon identifies the influencer campaign.
  url.searchParams.set('utm_source', 'influencer')
  url.searchParams.set('utm_medium', 'affiliate')
  url.searchParams.set('utm_campaign', couponCode)
  url.searchParams.set('utm_content', 'share_button')
  return url.toString()
}

interface ShareBrowser {
  share?: (data: ShareData) => Promise<void>
  clipboard?: { writeText: (text: string) => Promise<void> }
}

/** Invoke directly from the press so the native sheet retains the browser's user activation. */
export async function shareInfluencerUrl(url: string, native: boolean, browser: ShareBrowser = navigator): Promise<'shared' | 'copied' | 'cancelled'> {
  if (native && browser.share) {
    try {
      await browser.share({ url })
      return 'shared'
    }
    catch (error) {
      if (error && typeof error === 'object' && 'name' in error && error.name === 'AbortError')
        return 'cancelled'
      // Unsupported or blocked native sharing still leaves the clipboard available.
    }
  }
  if (!browser.clipboard)
    throw new Error('Clipboard unavailable')
  await browser.clipboard.writeText(url)
  return 'copied'
}
